import appStyles from "../../../App.module.css";
import { portugueseUrlAndDocs } from "../../config/portuguese-Constant";
const PPFooter = () => {
  return (
    <div className={appStyles.footerContentWrapper}>
      <p>
        By continuing, you agree to our&nbsp;
        <a href={portugueseUrlAndDocs.privacyPolicy} target="_blank" rel="noopener noreferrer">
          &nbsp;Privacy Policy
        </a>
        ,&nbsp;
        <a href={portugueseUrlAndDocs.termsAndConditions} target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </a>
        , and&nbsp;
        <a href={portugueseUrlAndDocs.cookiePolicy} target="_blank" rel="noopener noreferrer">
          Cookie Policy.
        </a>
      </p>
      <p>
        This insurance is provided by battleface Underwriting Services SRL, mandated underwriter acting on behalf of Eir
        Forsakring, with its registered office at Avenue des Arts 6,1210 Brussels, Belgium. This contract of insurance
        is insured by Eir Forsakring AB.
      </p>
    </div>
  );
};

export default PPFooter;
